import { X } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export const STAFF_ROLES = [
  { value: "system_administrator", label: "System Administrator" },
  { value: "operations", label: "Operations" },
  { value: "staffing_coordinator", label: "Staffing Coordinator" },
  { value: "recruiter", label: "Recruiter" },
  { value: "hr", label: "HR" },
  { value: "executive", label: "Executive" },
];

export const roleLabel = (role) => STAFF_ROLES.find((item) => item.value === role)?.label || role;

export const TeamMemberForm = ({ form, isSaving, mode, onChange, onClose, onSubmit }) => {
  const { user } = useAuth();
  const grantableRoles = STAFF_ROLES.filter((role) => user?.role === "system_administrator" || role.value !== "system_administrator");
  const isEdit = mode === "edit";
  const update = (field) => (event) => onChange({ ...form, [field]: event.target.value });
  return (
    <section className="inline-edit-panel team-member-panel" data-testid="team-member-form-panel">
      <div className="section-heading">
        <div>
          <h2>{isEdit ? "Edit staff member" : "Add staff member"}</h2>
          <p>
            {isEdit
              ? "Update the person's name, title, or role. Role changes apply on their next request."
              : "A temporary password is generated once and must be changed at first sign-in."}
          </p>
        </div>
        <button
          aria-label="Close staff form"
          className="projection-icon-button"
          data-testid="close-team-member-form"
          type="button"
          onClick={onClose}
        >
          <X size={16} />
        </button>
      </div>
      <form className="inline-edit-form team-member-form" data-testid="team-member-form" onSubmit={onSubmit}>
        <label>
          First name
          <input data-testid="team-first-name-input" value={form.first_name} onChange={update("first_name")} required />
        </label>
        <label>
          Last name
          <input data-testid="team-last-name-input" value={form.last_name} onChange={update("last_name")} />
        </label>
        <label>
          Work email
          <input
            data-testid="team-email-input"
            disabled={isEdit}
            type="email"
            value={form.email}
            onChange={update("email")}
            required
          />
        </label>
        <label>
          Role
          <select data-testid="team-role-select" value={form.role} onChange={update("role")} required>
            {grantableRoles.map((role) => (
              <option key={role.value} value={role.value}>
                {role.label}
              </option>
            ))}
          </select>
        </label>
        <label className="inline-edit-full">
          <span className="field-label">
            Title<em className="field-optional">· optional</em>
          </span>
          <input
            data-testid="team-title-input"
            placeholder="e.g. HR Director"
            value={form.title}
            onChange={update("title")}
          />
        </label>
        <div className="inline-edit-full form-actions">
          <button className="button button-primary" data-testid="save-team-member-button" disabled={isSaving}>
            {isSaving ? "Saving…" : isEdit ? "Save changes" : "Create account"}
          </button>
        </div>
      </form>
    </section>
  );
};
